<style scoped>

.stat-panel {
  padding-left: 8px;
  padding-right: 8px;
}

</style>

<template>
  <div class="display-flex">
    <div class="flex-item">
      <ReactionPanel
        :mediaId="mediaId"
        :currentTime="currentTime"
        :type="media.type"
        :media="media"
        @onPause="$emit('onPause')"
        @onPlay="$emit('onPlay')"
        @onClickTag="$emit('onClickTag', $event)"
        :tag="tag"/>
    </div>
    <div class="stat-panel display-flex display-flex-column">
      <div class="flex-item"/>
      <StatPanel
        :mediaId="mediaId"
        :currentTime="currentTime"
        :type="media.type"
        :media="media" slot="right"/>
      <div class="flex-item"/>
    </div>
  </div>

</template>

<script>

// Components
import StatPanel from '@/components/Stat/StatPanel.vue'
import ReactionPanel from '@/components/Reaction/ReactionPanel.vue'

export default {
  name: 'MediaBar',
  components: {
    StatPanel,
    ReactionPanel
  },
  props: {
    mediaId: {
      type: String,
      required: true
    },
    type: {
      type: String
    },
    media: {
      type: Object,
      required: true
    },
    currentTime: {
      type: Number,
      required: true
    },
    playlistId: {
      type: String
    },
    isAdmin: {
      type: Boolean,
      required: true
    },
    tag: {
      type: Object,
      default() {
        return {
          action: '',
          tagId: ''
        }
      }
    },
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  watch: {

  },
  methods: {
    
  },
}
</script>
